import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import {
  ResultadosGanadores,
  ResultadosGenerales,
  ResultadosRama,
  ResultadosCategoria,
  controlesArrayFunc,
  ImprimirDatos,
  buildWinnersBoardData,
} from "./reportsLogic";
import { calcularSubclasificacion, buildSubclasificacionWinnersBoardData } from "./subclasificacionesLogic";
import Row from "./RowResultReport";
import WinnersBoardCompact from "./WinnersBoardCompact";
import CeremoniaPremiacion from "./CeremoniaPremiacion";
import SimpleDialogDemo from "../Modals/SimpleDialog";
import Background from "../../../assets/backgroundPhotos/fondogris_Dashport.jpg";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";

const ResultsReportNewAUTH = ({
  reportResultType,
  controles,
  codMod,
  gen,
  codCat,
  subclasifId,
  nombreSubclasificacion,
  soloGanadores,
}) => {
  const eventDetail = useSelector((state) => state.events.eventDetail);
  const eventResults = useSelector((state) => state.events.eventResults);
  const puntosControl = useSelector((state) => state.events.puntosControl);
  const eventConfiguration = useSelector((state) => state.events.eventConfiguration);
  const eventSubEvents = useSelector((state) => state.events.eventSubEvents);

  const subclasificaciones = useMemo(
    () =>
      (eventConfiguration &&
        eventConfiguration.timingConfig &&
        eventConfiguration.timingConfig.subclasificaciones) ||
      {},
    [eventConfiguration]
  );

  const [vistaCompacta, setVistaCompacta] = useState(false);

  const [filasTotal, setFilasTotal] = useState([]);
  const [currentRows, setCurrentRows] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loadAll, setLoadAll] = useState(false); // Nuevo estado para cargar todo
  const rowsPerPage = 100;
  const observerRef = useRef(null);

  useEffect(() => {
    if (eventDetail && eventResults && eventConfiguration) {
      const filasTotales = getReport();
      console.log("filasTotales",filasTotales)
      setFilasTotal(filasTotales);
      setCurrentRows(filasTotales.slice(0, rowsPerPage));
      setCurrentIndex(rowsPerPage);
    }
  }, [codMod, gen, codCat, puntosControl, subclasifId, soloGanadores, eventConfiguration]);


  console.log("FilasTotales", filasTotal.length, currentRows.length, rowsPerPage)

  // Compartido por getReport(), resultadosOrdendosGanadores y el tablero de
  // ganadores (ceremonia/compacta) — antes estaba duplicado en 2 lugares.
  const eventResultsFiltered = useMemo(() => {
    if (!eventResults) return [];
    return eventResults.filter((a) => {
      if (codMod && gen && codCat) {
        return a.codMod === codMod && a.gen === gen && a.codCat === codCat;
      }
      if (codMod && gen) {
        return a.codMod === codMod && a.gen === gen;
      }
      if (codMod) {
        return a.codMod === codMod;
      }
      return true; // Si no hay ningún filtro activo, devuelve todos los elementos.
    });
  }, [eventResults, codMod, gen, codCat]);

  const getReport = () => {
    let resultadosOrdendos;

    switch (reportResultType) {
      case 4:
        resultadosOrdendos = ResultadosGanadores(eventResultsFiltered);
        break;
      case 1:
        resultadosOrdendos = ResultadosGenerales(eventResultsFiltered);
        break;
      case 2:
        resultadosOrdendos = ResultadosRama(eventResultsFiltered);
        break;
      case 3:
        resultadosOrdendos = ResultadosCategoria(eventResultsFiltered);
        break;
      case 5:
        resultadosOrdendos = calcularSubclasificacion(eventResultsFiltered, subclasifId).map((r) => ({
          ...r,
          nombreSubclasificacion,
        }));
        // "Ver ganadores" recorta al top-N configurado para esta
        // subclasificación — si no tiene cantidadGanadores definido, no hay
        // top-N que mostrar (queda vacío en vez de mostrar todo, para no
        // confundir "ganadores" con "todos").
        if (soloGanadores) {
          const cantidad = subclasificaciones[subclasifId] && subclasificaciones[subclasifId].cantidadGanadores;
          resultadosOrdendos = resultadosOrdendos.filter(
            (r) => cantidad && r.pSub !== null && r.pSub <= cantidad
          );
        }
        break;
      default:
        resultadosOrdendos = eventResultsFiltered;
    }

    const iDEvento = eventDetail.iDEvento;
    let filas = ImprimirDatos(
      resultadosOrdendos,
      reportResultType,
      true,
      controles,
      true,
      iDEvento,
      eventConfiguration && eventConfiguration.timingConfig
    );

    // El tab Ganadores, además de absolutos/categorías, también muestra los
    // ganadores de cada subclasificación que tenga cantidadGanadores
    // configurado — una sección más por subclasificación, al final.
    if (reportResultType === 4) {
      Object.keys(subclasificaciones).forEach((id) => {
        const def = subclasificaciones[id];
        if (!def.cantidadGanadores) return;
        const ganadoresSub = calcularSubclasificacion(eventResultsFiltered, id)
          .filter((r) => r.pSub !== null && r.pSub <= def.cantidadGanadores)
          .map((r) => ({ ...r, nombreSubclasificacion: def.nombre }));
        if (ganadoresSub.length) {
          filas = filas.concat(
            ImprimirDatos(
              ganadoresSub,
              5,
              true,
              controles,
              true,
              iDEvento,
              eventConfiguration && eventConfiguration.timingConfig
            )
          );
        }
      });
    }

    return filas;
  };

  const resultadosOrdendosGanadores = useMemo(() => {
    if (reportResultType !== 4) return [];
    return ResultadosGanadores(eventResultsFiltered);
  }, [reportResultType, eventResultsFiltered]);

  const winnersBoardData = useMemo(
    () =>
      buildWinnersBoardData(resultadosOrdendosGanadores, eventSubEvents).concat(
        buildSubclasificacionWinnersBoardData(eventResultsFiltered, subclasificaciones, eventSubEvents)
      ),
    [resultadosOrdendosGanadores, eventSubEvents, eventResultsFiltered, subclasificaciones]
  );

  const loadMoreRows = useCallback(() => {
    if (loadAll) return; // Evita cargar más filas si se quiere mostrar todo

    const nextIndex = currentIndex + rowsPerPage;
    const newRows = filasTotal.slice(currentIndex, nextIndex);
    setCurrentRows((prevRows) => [...prevRows, ...newRows]);
    setCurrentIndex(nextIndex);
  }, [currentIndex, filasTotal, loadAll]);

  // Intersection Observer para carga progresiva
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          loadMoreRows();
        }
      },
      { threshold: 1.0 }
    );

    if (observerRef.current && !loadAll) observer.observe(observerRef.current);

    return () => {
      if (observerRef.current) observer.unobserve(observerRef.current);
    };
  }, [loadMoreRows, loadAll]);

  // Función para cargar todas las filas
  const handleLoadAll = () => {
    setLoadAll(true);
    setCurrentRows(filasTotal); // Cargar todo de golpe
  };

  if (!eventDetail || !filasTotal.length) return <h5>Cargando</h5>;


  return (
    <div
      style={{
        backgroundImage: `url(${Background})`,
        backgroundRepeat: "repeat",
        //        backgroundSize: "cover",
        padding: "10px",
        backgroundSize:"100%"
      }}
    >
      {reportResultType === 4 && (
        <div style={{ textAlign: "center", marginBottom: "10px" }}>
          <Button
            variant={!vistaCompacta ? "contained" : "outlined"}
            color="primary"
            style={{ margin: 5 }}
            onClick={() => setVistaCompacta(false)}
          >
            Vista detallada
          </Button>
          <Button
            variant={vistaCompacta ? "contained" : "outlined"}
            color="primary"
            style={{ margin: 5 }}
            onClick={() => setVistaCompacta(true)}
          >
            Vista compacta
          </Button>
          <SimpleDialogDemo fullScreen={true} buttonText={"Ceremonia premiación"}>
            <CeremoniaPremiacion
              modalidadGroups={winnersBoardData}
              tituloEvento={eventDetail && eventDetail.nombreEvento}
            />
          </SimpleDialogDemo>
        </div>
      )}

      {reportResultType === 4 && vistaCompacta ? (
        <WinnersBoardCompact
          modalidadGroups={winnersBoardData}
          tituloEvento={eventDetail && eventDetail.nombreEvento}
        />
      ) : (
        <>
          {(!loadAll && filasTotal.length !== currentRows.length) && (
            <div style={{ textAlign: "center", marginTop: "20px" }}>
              <Button variant="contained" style={{ width: "100%", fontSize: 15, margin: 5 }} color="secondary" onClick={handleLoadAll}>
                Cargar todas las filas del reporte (puede tardar un poco sin son muchos participantes)
              </Button>
            </div>
          )}

          <Table>
            <TableBody>
              {currentRows.map((data, index) => {
                const controlesArray = controles ? controlesArrayFunc(puntosControl) : [];
                return (
                  <Row
                    key={index}
                    data={data}
                    controlesArray={controlesArray}
                    controles={controles}
                    align="center"
                  />
                );
              })}
              {!loadAll && (
                <TableRow>
                  <td ref={observerRef} style={{ height: "1px" }}></td>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </>
      )}
    </div>
  );
};

export default ResultsReportNewAUTH;

